import { InjectionToken } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'browser_session_id';

/**
 * Per-tab browser session ID (UUID v4, stored in sessionStorage).
 *
 * Persists for the tab's lifetime. Each new tab gets a unique ID.
 * Used for:
 * - Correlating Application Insights events to a specific browser tab
 * - Sending to SignalR server for per-tab correlation
 * - Multi-tab debugging in Kusto
 *
 * Uses `uuid`'s `v4()` rather than `crypto.randomUUID()`: the latter is only exposed in
 * secure contexts, so it is `undefined` when the beamer is opened over plain HTTP from
 * another machine on the classroom LAN. `v4()` prefers `randomUUID` when present and
 * falls back to `crypto.getRandomValues`, which is not secure-context gated.
 */
export const BROWSER_SESSION_ID = new InjectionToken<string>('BROWSER_SESSION_ID', {
    providedIn: 'root',
    factory: () => {
        const existing = sessionStorage.getItem(STORAGE_KEY);
        if (existing) {
            return existing;
        }
        const id = uuidv4();
        sessionStorage.setItem(STORAGE_KEY, id);
        return id;
    },
});
